import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gift-badge-cost position-absolute badge bg-white text-primary rounded-pill fw-bold fs-6" }


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftBadgeCost',
  props: {
  cost: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.cost) + " 🍋 ", 1))
}
}

})